module.exports = __webpack_public_path__ + "4d1359f5e82dec4d573bd4e11c5454e1.png";